module.exports = "<div class=\"container-menu\"></div>\n<col-alert-container></col-alert-container>\n\n<main class=\"container\">\n    <div class=\"container-spacer\">\n        <div id=\"router-loading\" style=\"text-align: center; margin-top: 25%; margin-top: calc(50vh - (83px / 2) - 51px);\">\n            <!-- Remover o fallback para o PHD 'margin-top: 25%' -->\n            <img src=\"assets/loading.gif\" width=\"83\" height=\"83\" alt=\"Carregando...\">\n        </div>\n\n        <router-outlet></router-outlet>\n    </div>\n</main>\n\n<col-footer></col-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main